import React from 'react';
import './App.css';
import MapView from './components/MapView';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';

const SlugView: React.FC = () => {
  const { slug = '' } = useParams();
  return (
    <div className="App">
      <main className="app-main">
        <MapView slug={slug} height="100vh" />
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/embed/:slug" element={<SlugView />} />
        <Route path="/:slug" element={<SlugView />} />
        <Route path="*" element={
          <div className="App">
            <header className="app-header">
              <h1>Carte Interactive</h1>
              <p>Explorez les points d'intérêt sur la carte</p>
            </header>
            <main className="app-main">
              <MapView 
                center={[48.8566, 2.3522]} 
                zoom={12}
                height="calc(100vh - 120px)"
              />
            </main>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
